import {RemoteAccessViewAsync as RemoteAccessView} from './RemoteAccessView.async';

export default RemoteAccessView;
